import { Component } from '@angular/core';
import { GLOBAL_CONFIRMATION_KEY } from '@core/constants';

@Component({
    selector: 'mnc-documents-shared-confirmation',
    template: `
    <p-confirmDialog
      acceptButtonStyleClass="mr-0"
      acceptIcon="none"
      defaultFocus="none"
      rejectButtonStyleClass="p-button-secondary"
      rejectLabel="Cancel"
      styleClass="custom-confirmation"
      [key]="key"
    ></p-confirmDialog>`,
    styles: [`
    ::ng-deep {
      .custom-confirmation {
        &.p-dialog {
          min-width: 400px;
          width: fit-content;
          max-width: 550px;
        }

        .p-dialog-header {
          padding: 1rem;

          .p-dialog-title {
            font-size: 1.25rem;
            line-height: 1.5rem;
          }

          .p-dialog-header-icon {
            color: #333;
          }
        }

        .p-dialog-content {
          padding: 0 1rem 1rem;

          .p-confirm-dialog-message {
            font-size: 0.875rem;
            line-height: 1.2rem;
          }
        }

        .p-dialog-footer {
          padding: 0 1rem 1rem;

          .p-button-icon {
            display: none;
          }
        }

        .break-word {
          inline-size: 500px;
          overflow-wrap: break-word;
        }
      }
    }
  `],
    standalone: false
})
export class SharedConfirmationComponent {
  key = GLOBAL_CONFIRMATION_KEY
}
